export default __webpack_public_path__ + "static/media/ic_report_48px.17bb84db.svg";